import Image from "next/image";
import { Center } from "@chakra-ui/react";
import DciGrahic from "public/internetAndDci/DCI_02.png";

const DCIGraphicImg = () => {
  return (
    <Center>
      <Image
        src={DciGrahic}
        alt="DCI Graphic Image"
        style={{ height: "auto", maxWidth: "800px", width: "100%" }}
      />
    </Center>
  );
};

export default DCIGraphicImg;
